class StickyHeader {

  private header: HTMLElement | null = null;
  private headerHeightReceiver: HTMLElement | null = null;
  private headerHeight: number = 0;

  private isScrolled: boolean = false;
  private isScrolledCheckInterval : number | null = null;

  private recentResizeHappened: boolean = false;


  constructor() {
    this.header = document.querySelector('.header');
    this.headerHeightReceiver = document.querySelector('.header-height-receiver');
    if(!this.header || !this.headerHeightReceiver) return;

    this.init();
  }

  checkIsScrolled() {
    if (window.scrollY > this.headerHeight) {
      this.isScrolled = true;
    } else {
      this.isScrolled = false;
    }
  }

  isScrolledInterval() {
    this.isScrolledCheckInterval = window.setInterval(() => {
      this.checkIsScrolled();
      this.makeHeaderSticky();
    }, 800);
  }

  clearIsScrolledInterval() {
    if (this.isScrolledCheckInterval) {
      window.clearInterval(this.isScrolledCheckInterval);
    }
  }

  makeHeaderSticky() {
    if(!this.header) return;
    if (this.isScrolled ) {
      this.header.classList.add('header--sticky');
    } else {
      if(!document.body.classList.contains('body--has-popup')) {
        this.header.classList.remove('header--sticky');
      }
    }
  }

  getHeaderHeight() {
    if(!this.header) return;
    this.headerHeight = this.header.offsetHeight;
  }

  setHeaderHeightReceiver() {
    if(!this.headerHeightReceiver) return;
    this.headerHeightReceiver.style.height = `${this.headerHeight}px`;
    this.recentResizeHappened = true;
    setTimeout(() => {
      this.recentResizeHappened = false;
    }, 500);
  }

  onResize() {
    this.getHeaderHeight();
    if(!this.recentResizeHappened) {
      this.setHeaderHeightReceiver();
    }
  }

  init() {
    this.getHeaderHeight();
    this.setHeaderHeightReceiver();
    this.header?.classList.add('header--deligated-height');
    this.isScrolledInterval();
    window.addEventListener('resize', this.onResize.bind(this));
  }
}

export default function stickyHeader(){
  return new StickyHeader();
};